import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSettlingTank = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 100,
	height: 80,
	viewBox: "0 0 100.0 80.0",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M 0.0 0.0 L 0.0 55.0 L 50.0 80.0 L 100.0 55.0 L 100.0 0.0",
		fill: "none",
		stroke: "currentColor",
		strokeWidth: 1
	})
});
export default SvgSettlingTank;
